<template>
    <div class="current_file">
        <a aria-label="View File" target="_blank" v-bind:href="url">View File #{{ num }}</a>
        <a @click="deleteFile($event)" class="text-danger delete_file" href="#">( Delete )</a>
    </div>
</template>

<script>
    export default {
        props: ['id', 'responseId', 'ajax', 'url', 'num'],

        mounted() {
            // console.log('Component mounted.')
        },

        data: function () {
            return {}
        },

        methods: {
            deleteFile(event) {
                event.preventDefault();

                let responseFile = this, $this = $(event.target);

                if (!$this.hasClass('disabled')) {

                    $this.toggleClass('disabled', true);

                    let dialog = bootbox.dialog({
                        title: "Delete File?",
                        message: "This file will not be able to be restored.",
                        buttons: {
                            cancel: {
                                label: '<i class="fa fa-times"></i> Cancel',
                                callback: function () {
                                    //
                                }
                            },
                            confirm: {
                                label: '<i class="fa fa-check"></i> Confirm',
                                className: 'btn-danger',
                                callback: function () {
                                    dialog.find('.modal-footer').remove();

                                    dialog.find('.bootbox-body').html('<p><i class="fa fa-spin fa-spinner"></i> Please wait...</p>');

                                    axios.post(responseFile.ajax, {
                                        id: responseFile.id,
                                        responseId: responseFile.responseId
                                    })
                                        .then(response => {
                                            if (response.data.response == 'ok') {

                                                dialog.find('.bootbox-body').html('<p>File Deleted!</p>');

                                                $this.parents('.current_file').remove();

                                            } else {

                                                $this.toggleClass('disabled', false);

                                                dialog.find('.bootbox-body').html('<p>File could not be deleted!</p>');
                                            }

                                            setTimeout(function () {
                                                dialog.modal('hide');
                                            }, 500);
                                        })
                                        .catch(errors => {
                                            console.log(errors);

                                            $this.toggleClass('disabled', false);

                                            dialog.find('.bootbox-body').html('<p>File could not be deleted!</p>');

                                            setTimeout(function () {
                                                dialog.modal('hide');
                                            }, 500);
                                        });

                                    return false;
                                }
                            }
                        }
                    });

                }
            },
        }
    }
</script>
